<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="fullPage">
            </loading>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </b-col>
                    <b-col cols="4">
                       <base-button type="success" @click="newSaleDocument" class="float-right">
                          <i class="fa fa-plus"></i>
                          <!-- {{language_terms['NEW']}} -->
                          <!-- {{type == 'SQ' ? language_terms['SALE_QUOTATION'] : ( type == 'SO' ? language_terms['ORDER'] : 
                          (type == 'SI' ? language_terms['INVOICE'] : language_terms['DELIVERY_ORDER']))}} -->
                        </base-button>

                        <base-button type="primary" @click="newInvoiceFromDO" class="float-right mr-4" v-if="type == 'SI' && 0">
                          <i class="fa fa-clone"></i>
                          From DO
                          <!-- {{language_terms['INVOICE_FROM_DO']}} -->
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col lg="3" >
                    <base-input :label="language_terms['DOCUMENT'] + ' # / ' + language_terms['CUSTOMER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch">
                    </base-input>
                  </b-col>
                  <b-col lg="4" >
                    <base-input :label="language_terms['PRODUCT']" v-model="filter.product" v-on:keyup.enter="clickOnSearch">
                    </base-input>
                  </b-col>
                  <b-col lg="1">
                    <base-input :label="language_terms['DATE_FROM']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.from_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col lg="1">
                    <base-input :label="language_terms['DATE_TO']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.to_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <!-- <b-col md="2">
                    <base-input label="Sales Type">
                      <el-select v-model="filter.type" filterable>
                        <el-option v-for="option in sales_types"
                                  :key="option.value"
                                  :label="option.label"
                                  :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col> -->
                  <b-col lg="2" v-if="type !== 'DO'">
                    <base-input :label="language_terms['STATUS']">
                      <el-select v-model="filter.status" filterable>
                        <el-option v-for="option in status_options"
                                  :key="option.value"
                                  :label="option.label"
                                  :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  <b-col lg="1" class="mt-4">
                    <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col cols="12">
                    <base-button type="primary" @click="clickOnSearch"><i class="fa fa-search"></i></base-button>
                  </b-col>
                </b-row> -->
              </card>
              <!-- Search Results -->
              <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0 && type !='DO'"/>

              <PaginatedTables :myColumns="do_tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0 && type =='DO'"/>

            </div>
          </b-col>
        </b-row>
        <!-- <a href="javascript:void(0)" class="float" @click="newSaleDocument">
          <i class="fa fa-plus my-float"></i>
        </a> -->
      </b-container>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  props:
  {
        type: {
          type: String,
          default: 'SQ',
          description: 'Sales Type',
          required:true
        },
        addNew: {
          type: String,
          default: 'Add New Sale Document',
          description: 'Add New Sale Document',
          required:true
        },
  },
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        sales_filter:state => state.sales.filter,
        sales_quotations: state => state.sales.sales_quotations,
        sales_orders: state => state.sales.sales_orders,
        sales_invoices: state => state.sales.sales_invoices,
        dos: state => state.dos.dos,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,

      }),
    },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
    sales_quotations: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.sales_quotations
      }
    },
    sales_invoices: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.sales_invoices
      }
    },
    sales_orders: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.sales_orders
      }
    },
    dos: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.dos
      }
    }
  },
  async mounted()
  {
      // console.log(this.type)
      this.filter.type = this.type
      this.loading = true
      if(this.type != 'DO' && this.items.length == 0)
      {
        this.filter.limit = 20
        await this.$store.dispatch("sales/quickSearch", this.filter);
      }

      this.loading = false
      if(this.type == 'SQ')
      {
          this.items = this.sales_quotations
      }
      else if(this.type == 'SO')
      {
        this.items = this.sales_orders

      }
      else if(this.type == 'SI')
      {
        this.items = this.sales_invoices
      }
      else if(this.type == 'DO')
      {
        this.items = this.dos
      }
      this.updateTableLang()

      if(this.sales_filter)
      {
        this.filter = this.sales_filter
      }
  },
  data(){
    return{
      fullPage:true,
      loading:false,
      filter:{
        keyword:"",
        product:"",
        date_from:null,
        date_to:null,
        type:null,
        status:'ALL',
  
      },
      items:[],
      do_tableColumns: [
            {
              prop: 'code',
              label: 'Document#',
              minWidth: 100,
              sortable: true,
              key:'CODE'

            },
            {
              prop: 'contact_name',
              label: 'Customer',
              minWidth: 240,
              sortable: true,
              key:'CUSTOMER'

            },
            {
              prop: 'movement_date',
              label: 'Date',
              minWidth: 60,
              sortable: true,
              key:'DATE'

            },
            {
              prop: 'reference',
              label: 'Reference',
              minWidth: 130,
              sortable: true,
              key:'REFERENCE'

            }
      ],
      tableColumns: [
            {
              prop: 'code',
              label: 'Document#',
              minWidth: 80,
              sortable: true,
              key:'DOCUMENT'

            },
            {
              prop: 'contact_name',
              label: 'Customer',
              minWidth: 300,
              sortable: true,
              key:'CUSTOMER'

            },
            {
              prop: 'date',
              label: 'Date',
              minWidth: 60,
              sortable: true,
              key:'DATE'

            },
            {
              prop: 'reference',
              label: 'Reference',
              minWidth: 120,
              sortable: true,
              key:'REFERENCE'

            },
            {
              prop: 'salesperson_contact_name',
              label: 'Sales Person',
              minWidth: 120,
              sortable: true,
              key:'SALESPERSON'

            },
            {
              prop: 'status',
              label: 'Status',
              minWidth: 90,
              sortable: true,
              key:'STATUS'

            },
      ],
      status_options:[
        {
          label:"ALL",
          value:"ALL"
        },
        {
          label:"OPEN",
          value:"OPEN"
        },
        {
          label:"APPROVED",
          value:"APPROVED"
        },
        {
          label:"PRINTED",
          value:"PRINTED"
        },
        {
          label:"REJECTED",
          value:"REJECTED"
        },
        {
          label:"POSTED",
          value:"POSTED"
        },
      ],
      sales_types:[
        {
          label:"Quotation",
          value:"SQ"
        },
        {
          label:"Order",
          value:"SO"
        },
        {
          label:"Invoice",
          value:"SI"
        }
      ]

    }
  },

  methods:{
    updateTableLang(){
      if(this.type != 'DO')
      {
        for(let i=0; i < this.tableColumns.length;i++)
        {
          let key = this.tableColumns[i].key
          this.tableColumns[i].label = this.language_terms[key]
        }
      }
      else
      {
        for(let i=0; i < this.do_tableColumns.length;i++)
        {
          let key = this.do_tableColumns[i].key
          this.do_tableColumns[i].label = this.language_terms[key]
        }
      }

    },
    async clickOnSearch(){
      this.filter.type = this.type
      this.filter.limit = ''
      this.loading = true
      if(this.type != 'DO')
        await this.$store.dispatch("sales/quickSearch", this.filter);
      else
        await this.$store.dispatch("dos/quickSearch", this.filter);

      this.loading = false
    },
    clickOnReset(){
      this.filter = {
          keyword:"",
          date_from:null,
          date_to:null,
          type:'SQ',
          status:'ALL'
      }
    },
    async newSaleDocument(){
       this.$router.push(this.$props.addNew+"_new")
    },
    newInvoiceFromDO()
    {
       this.$router.push("/sales/sales-invoice-from-do/_new")
    },
  }
}
</script>
